module.exports = __webpack_public_path__ + "img/43200.bb26e4cf.jpg";